import { render, staticRenderFns } from "./BIcon.vue?vue&type=template&id=b1d8937c&"
import script from "./BIcon.vue?vue&type=script&lang=js&"
export * from "./BIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports